// extracted by mini-css-extract-plugin
export default {"wrapper":"lExcd","title":"p0X2J","title--left":"MT5tz","input":"t77PL"};